// import React, { useState, useEffect, useRef } from 'react';

// import PropTypes from 'prop-types';
// import {
//   BrowserQRCodeReader,
//   NotFoundException,
//   ChecksumException,
//   FormatException,
// } from '@zxing/library';
// import {
//   Button,
//   Dialog,
//   FormControl,
//   Grid,
//   InputLabel,
//   MenuItem,
//   Select,
//   Typography,
// } from '@mui/material';
// import { BsQrCode } from 'react-icons/bs';
// import { IoIosCloseCircleOutline } from 'react-icons/io';

// function QrCode({ handleClose, open, setOpen, setQr }) {
//   const [selectedDeviceId, setSelectedDeviceId] = useState('');
//   const [code, setCode] = useState('');
//   const [videoInputDevices, setVideoInputDevices] = useState([]);
//   const codeReaderRef = useRef(new BrowserQRCodeReader()); // Use useRef to avoid re-initialization

//   console.log('ZXing code reader initialized');
//   console.log('code', code);
//   useEffect(() => {
//     const codeReader = codeReaderRef.current; // Use referenced codeReader

//     async function setupDevices() {
//       try {
//         const devices = await codeReader.getVideoInputDevices();
//         setSelectedDeviceId(devices[0]?.deviceId || '');
//         setVideoInputDevices(devices);
//       } catch (err) {
//         console.error(err);
//       }
//     }

//     setupDevices();

//     let timeoutId;

//     async function decodeContinuously() {
//       // Decode only when it is open
//       try {
//         if (open) {
//           await codeReader.decodeFromInputVideoDeviceContinuously(
//             selectedDeviceId,
//             'video',
//             (result, err) => {
//               if (result) {
//                 console.log('Found QR code!', result);
//                 setQr(result.text);
//                 alert(result.text);
//                 handleClose();
//                 setCode(result.text);
//               }

//               if (err) {
//                 setCode('');

//                 if (err instanceof NotFoundException) {
//                   console.log('No QR code found.');
//                 } else if (err instanceof ChecksumException) {
//                   console.log("A code was found, but it's read value was not valid.");
//                 } else if (err instanceof FormatException) {
//                   console.log('A code was found, but it was in an invalid format.');
//                 } else {
//                   console.error('Unknown error during decoding:', err);
//                 }
//               }
//             }
//           );
//         } else {
//           clearTimeout(timeoutId);
//         }
//       } catch (error) {
//         console.error('Error decoding continuously:', error);
//       }
//     }

//     timeoutId = decodeContinuously();

//     return () => {
//       codeReader.reset(); // Reset on cleanup
//       clearTimeout(timeoutId);
//     };
//   }, [selectedDeviceId, setOpen, open, setQr, handleClose]); // Dependency on selectedDeviceId and open

//   function resetClick() {
//     setCode('');
//     console.log('Reset.');
//   }
//   console.log('videoInputDevices', videoInputDevices);

//   return (
//     <Dialog onClose={handleClose} open={open} fullWidth maxWidth="sm">
//       <div
//         style={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           padding: '1rem',
//         }}
//       >
//         <div
//           style={{
//             display: 'flex',
//             gap: '4px',
//             alignItems: 'center',
//             padding: '1rem',
//           }}
//         >
//           <BsQrCode size={32} />
//           <Typography variant="h6">Scan QR Code</Typography>
//         </div>

//         <IoIosCloseCircleOutline size={32} onClick={handleClose} style={{ cursor: 'pointer' }} />
//       </div>
//       <Typography sx={{ marginLeft: '20px' }}>Switch Camera</Typography>
//       <div style={{ padding: '1rem' }} className="frmfld">
//         <FormControl fullWidth>
//           <Select
//             labelId="sourceSelectLabel"
//             value={selectedDeviceId}
//             onChange={(e) => {
//               console.log('hii', e.target.value);
//               setSelectedDeviceId(e.target.value);
//             }}
//             fullWidth
//             sx={{ mb: 1 }}
//           >
//             {videoInputDevices.map((device) => (
//               <MenuItem key={device.deviceId} value={device.deviceId}>
//                 {device.label}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//         <video
//           id="video"
//           width="100%"
//           height="auto"
//           muted
//           autoPlay
//           style={{ marginBottom: '1rem' }}
//         />
//         {/* <Typography variant="subtitle1" style={{ marginBottom: '0.5rem' }}>
//           Scanned Result:
//         </Typography> */}
//         <Typography variant="body1" style={{ whiteSpace: 'pre-wrap' }}>
//           {code}
//         </Typography>
//         {/* <Button
//           variant="outlined"
//           color="primary"
//           onClick={resetClick}
//           style={{ marginTop: '1rem' }}
//         >
//           Reset
//         </Button> */}
//       </div>
//     </Dialog>
//   );
// }

// QrCode.propTypes = {
//   handleClose: PropTypes.func.isRequired,
//   open: PropTypes.bool.isRequired,
//   setOpen: PropTypes.func.isRequired,
//   setQr: PropTypes.func.isRequired,
// };
// export default QrCode;

// part 2 of qr scanner
import { Card, Dialog, DialogTitle } from '@mui/material';
import { Box, Stack, height } from '@mui/system';
import React, { useState, useRef, useEffect } from 'react'; // Import useEffect
import { BsQrCode } from 'react-icons/bs';
import QrReader from 'react-qr-scanner';
import { Toaster, toast } from 'sonner';
import PropTypes from 'prop-types';
import AlertView from 'src/sections/_examples/mui/alert-view';
import { RxCrossCircled } from 'react-icons/rx';

function QrCode({ handleClose, open, setOpen, setQr, handleScan }) {
  const [result, setResult] = useState('');
  const scannerRef = useRef(null);

  // Function to initialize the scanner with the desired camera
  useEffect(() => {
    const initScanner = async () => {
      console.log('device');
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();

        const rearCamera = devices.find(
          (device) => device.kind === 'videoinput' && device.label.toLowerCase().includes('back')
        );
        if (rearCamera) {
          const stream = await navigator.mediaDevices.getUserMedia({
            video: { deviceId: rearCamera.deviceId },
          });
          scannerRef.current.streamRef.current.srcObject = stream;
        } else {
          console.error('Rear camera not found.');
        }
      } catch (error) {
        console.error('Error accessing camera:', error);
      }
    };
    initScanner();
  }, []);

  const handleError = (error) => {
    console.error(error);
  };

  return (
    <div>
      <Dialog onClose={handleClose} open={open}>
        <Box p={2}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              cursor: 'pointer',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '1px' }} className="usrFrmFld">
              <DialogTitle>Scan QR Code</DialogTitle>
              <BsQrCode size={32} />
            </Box>
            <RxCrossCircled size={32} onClick={() => setOpen(false)} />
          </div>

          <Card sx={{ borderRadius: '20px', boxShadow: 5 }}>
            <QrReader
              ref={scannerRef}
              delay={300}
              onError={handleError}
              onScan={handleScan}
              constraints={{
                audio: false,
                video: { facingMode: 'environment' },
              }}
              style={{ height: '50vh' }}
            />
          </Card>
          {/*
          <button type="button" onClick={openImageDialog}>
            Scan QR Code from Image
          </button> */}
        </Box>
      </Dialog>
      <Toaster richColors />
    </div>
  );
}

export default QrCode;



// Part 3

// import React, { useState, useRef, useEffect } from 'react';
// import { Dialog, DialogTitle, Box, Card } from '@mui/material';
// import { BsQrCode } from 'react-icons/bs';
// import { RxCrossCircled } from 'react-icons/rx';
// import { QrReader } from 'react-qr-reader';
// // import { Toaster } from 'react-hot-toast';

// function QrCode({ handleClose, open, setOpen, setQr, handleScan }) {

//   const handleError = (error) => {
//     console.error('QR Reader Error:', error);
//   };

//   return (
//     <div>
//       <Dialog onClose={handleClose} open={open}>
//         <Box p={2}>
//           <div
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'space-between',
//               cursor: 'pointer',
//             }}
//           >
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: '1px' }} className="usrFrmFld">
//               <DialogTitle>Scan QR Code</DialogTitle>
//               <BsQrCode size={32} />
//             </Box>
//             <RxCrossCircled size={32} onClick={() => setOpen(false)} />
//           </div>

//           <Card sx={{ borderRadius: '20px', boxShadow: 5 }}>
//             <QrReader
//               // ref={scannerRef}
//               // delay={300}
//               onError={handleError}
//               onScan={handleScan}
//               constraints={{ facingMode: 'environment' }}
//               style={{ height: '50vh' }}
//             />
//           </Card>
//         </Box>
//       </Dialog>
//       {/* <Toaster richColors /> */}
//     </div>
//   );
// }
// export default QrCode;


QrCode.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  setQr: PropTypes.func.isRequired,
  handleScan: PropTypes.func.isRequired,
};

